import { apiRequest, handleCall } from 'syft-acp-core/api/call'

export const fetchIndustries = ({ employerId = null }) =>
  new Promise((resolve, reject) => {
    const req = apiRequest({ path: '/industries', reqArgs: { employer_id: employerId } })
    handleCall(req, resolve, reject, true, { employer_id: employerId })
  })
